export { default as LcTextCard } from './lcTextCard';
export { lcTextCardType } from './lcTextCard.types';
export { lcTextCardFragment } from './lcTextCard.fragment';
export { lcTextCardStandard } from './__fixtures__/lcTextCard';
